const DocMenuConfig = [
    {
        pages: [
            {
                heading: "dashboard",
                route: "/dashboard",
                svgIcon: "/media/icons/duotune/art/art002.svg",
                fontIcon: "bi-app-indicator",
            },
            {
                sectionTitle: "userManagement",
                route: "/user",
                svgIcon: "/media/icons/duotune/communication/com006.svg",
                fontIcon: "bi-person",
                sub: [
                    {
                        heading: "userAdd",
                        route: "/user/save",
                    },
                    {
                        heading: "userList",
                        route: "/user",
                    },
                    {
                        heading: "userRoles",
                        route: "/user/role",
                    },
                ]
            },
            {
                sectionTitle: "companyManagement",
                route: "/company",
                svgIcon: "/media/icons/duotune/communication/com006.svg",
                fontIcon: "bi-person",
                sub: [
                    {
                        heading: "companyAdd",
                        route: "/company/save",
                    },
                    {
                        heading: "companyList",
                        route: "/company",
                    },
                    {
                        heading: "companySpecialty",
                        route: "/company/specialty",
                    },
                ]
            },
        ],
    },
    {
        heading: "ecommerceManagement",
        route: "/ecommerce",
        pages: [
            {
                sectionTitle: "productManagement",
                route: "/ecommerce/product",
                svgIcon: "/media/icons/duotune/communication/com006.svg",
                fontIcon: "bi-person",
                sub: [
                    {
                        heading: "productAdd",
                        route: "/ecommerce/product/save",
                    },
                    {
                        heading: "productList",
                        route: "/ecommerce/product",
                    }
                ]
            },
            {
                sectionTitle: "subscriptionManagement",
                route: "/ecommerce/subscription",
                svgIcon: "/media/icons/duotune/communication/com006.svg",
                fontIcon: "bi-person",
                sub: [
                    {
                        heading: "subscriptionAdd",
                        route: "/ecommerce/subscription/save",
                    },
                    {
                        heading: "subscriptionList",
                        route: "/ecommerce/subscription",
                    }
                ]
            },
            {
                sectionTitle: "checkoutManagement",
                route: "/ecommerce/checkout",
                svgIcon: "/media/icons/duotune/communication/com006.svg",
                fontIcon: "bi-person",
                sub: [
                    {
                        heading: "checkoutAdd",
                        route: "/ecommerce/checkout/save",
                    },
                    {
                        heading: "checkoutList",
                        route: "/ecommerce/checkout",
                    }
                ]
            },
            {
                sectionTitle: "promotionManagement",
                route: "/ecommerce/promotion",
                svgIcon: "/media/icons/duotune/communication/com006.svg",
                fontIcon: "bi-person",
                sub: [
                    {
                        heading: "promotionAdd",
                        route: "/ecommerce/promotion/save",
                    },
                    {
                        heading: "promotionList",
                        route: "/ecommerce/promotion",
                    }
                ]
            },
            {
                heading: "paymentMethod",
                route: "/ecommerce/payment-method",
                svgIcon: "/media/icons/duotune/art/art002.svg",
                fontIcon: "bi-app-indicator",
            },
        ]
    },
    {
        heading: "moduleManagement",
        route: "/module",
        pages: [
            {
                heading: "modules",
                route: "/module",
                svgIcon: "/media/icons/duotune/abstract/abs027.svg",
                fontIcon: "bi-layers",
            },
        ]
    },


    {
        heading: "commonManagement",
        route: "/common",
        pages: [
            {
                heading: "vehicleBrand",
                route: "/common/vehicle/brand",
                svgIcon: "/media/icons/duotune/art/art002.svg",
                fontIcon: "bi-app-indicator",
            },
        ],
    },
];

export default DocMenuConfig;
